import { router } from '@inertiajs/react'
import { useEffect, useRef, useState } from 'react'

export default function useRefresh(context: string, blocks: string[], listSelection?: string) {
  const [refreshing, setRefreshing] = useState(false)
  const active = useRef({ context, remaining: 0 })
  useEffect(() => { active.current = { context, remaining: 0 }; setRefreshing(false) }, [context])
  function refresh() {
    if (active.current.remaining > 0) return
    active.current = { context, remaining: blocks.length }
    setRefreshing(true)
    if (listSelection) {
      // Establish one fresh server-timed window before its deferred groups load.
      const [path, query = ''] = listSelection.split('?')
      const parameters = new URLSearchParams(query)
      parameters.set('refresh', '1')
      parameters.delete('cursor')
      router.get(path, Object.fromEntries(parameters), { preserveState: true, preserveScroll: true, onFinish: () => {
        if (active.current.context !== context) return
        active.current.remaining = 0
        setRefreshing(false)
      } })
      return
    }
    // Each deferred group retains its own request and failure boundary.
    blocks.forEach((block) => router.reload({ only: [block], async: true, onFinish: () => {
      if (active.current.context !== context) return
      active.current.remaining -= 1
      if (active.current.remaining === 0) setRefreshing(false)
    } }))
  }
  return { refreshing, refresh }
}
